import React from 'react';

import { Card } from './Card';
import CardControls from './CardControls';
import './card.less';


const OverlayCard = (props) => {
	return (
		<Card>
			<CardControls onClose={props.onClose} onNext={props.onNext} onPrevious={props.onPrevious} />
			{props.children}
		</Card>
	);
}

export default OverlayCard;



// WEBPACK FOOTER //
// ./src/react/card/OverlayCard.jsx